var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 7.94336H5.16634C3.87768 7.94336 2.83301 8.98803 2.83301 10.2767V19.225C2.83301 20.5137 3.87768 21.5584 5.16634 21.5584H23.833C25.1217 21.5584 26.1663 20.5137 26.1663 19.225V10.2767C26.1663 8.98803 25.1217 7.94336 23.833 7.94336Z",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 8.51465C7.49967 9.75233 7.00801 10.9393 6.13284 11.8145C5.25767 12.6897 4.07068 13.1813 2.83301 13.1813V13.1813",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83301 16.2383C4.07068 16.2383 5.25767 16.7299 6.13284 17.6051C7.00801 18.4803 7.49967 19.6673 7.49967 20.9049",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20.9049C21.5 19.6673 21.9917 18.4803 22.8668 17.6051C23.742 16.7299 24.929 16.2383 26.1667 16.2383",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 13.1813C24.929 13.1813 23.742 12.6897 22.8668 11.8145C21.9917 10.9393 21.5 9.75233 21.5 8.51465V8.51465",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4993 17.0905C15.788 17.0905 16.8327 16.0458 16.8327 14.7572C16.8327 13.4685 15.788 12.4238 14.4993 12.4238C13.2107 12.4238 12.166 13.4685 12.166 14.7572C12.166 16.0458 13.2107 17.0905 14.4993 17.0905Z",
    stroke: "#FAFBFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyWhite);
export default __webpack_public_path__ + "static/media/moneyWhite.c49bb669.svg";
export { ForwardRef as ReactComponent };